import styled from "@emotion/styled";

import { fontRobotoCondensed } from "shared/lib/styles";

export const Header = styled.div`
  display: flex;
  gap: 32px;
  align-items: center;
`;

export const PageTitle = styled.div`
  color: #000000;
  font-weight: 400;
  font-size: 32px;
  font-family: ${fontRobotoCondensed};
  font-style: normal;
  line-height: 100%;
  text-transform: uppercase;
`;
